<div class="container-fluid mt-4 h-100">
  <div class="row h-100">
    <div class="col-md-8 offset-md-2">
      <div class="card h-100 d-flex flex-column">
        <!-- Header -->
        <div class="card-header bg-primary text-white">
          <h4 class="mb-0">
            <i class="material-icons" style="vertical-align: middle;">chat</i>
            Application Chat
          </h4>
          <div class="mt-2">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text bg-white">
                  <i class="material-icons" style="font-size: 18px;">assignment</i>
                </span>
              </div>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="applicationId"
                placeholder="Enter Application ID"
                [disabled]="isListening"
                (keyup.enter)="startListening()"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-success"
                  *ngIf="!isListening"
                  (click)="startListening()"
                  [disabled]="!applicationId"
                >
                  <i class="material-icons" style="vertical-align: middle; font-size: 18px;">play_arrow</i>
                  Start Chat
                </button>
                <button
                  class="btn btn-warning"
                  *ngIf="isListening"
                  (click)="stopListening()"
                >
                  <i class="material-icons" style="vertical-align: middle; font-size: 18px;">stop</i>
                  Stop Chat
                </button>
              </div>
            </div>

            <div class="mt-2">
              <small>
                <span [class.badge]="true"
                      [class.badge-success]="isConnected"
                      [class.badge-secondary]="!isConnected">
                  <i class="material-icons" style="vertical-align: middle; font-size: 12px;">
                    {{ isConnected ? 'check_circle' : 'cancel' }}
                  </i>
                  {{ isConnected ? 'Connected' : 'Disconnected' }}
                </span>
                <span class="ml-2"
                      [class.badge]="true"
                      [class.badge-info]="isListening"
                      [class.badge-secondary]="!isListening">
                  <i class="material-icons" style="vertical-align: middle; font-size: 12px;">
                    {{ isListening ? 'hearing' : 'hearing_disabled' }}
                  </i>
                  {{ isListening ? 'Listening' : 'Not Listening' }}
                </span>
              </small>
            </div>
          </div>
        </div>

        <!-- Error Display -->
        <div *ngIf="error" class="alert alert-danger m-3 mb-0">
          <i class="material-icons" style="vertical-align: middle;">error</i>
          <strong>Error:</strong> {{ error }}
        </div>

        <!-- Messages Area -->
        <div class="card-body flex-grow-1 overflow-auto" style="max-height: 500px;" #messagesContainer>
          <div *ngIf="!isListening" class="text-center text-muted py-5">
            <i class="material-icons" style="font-size: 48px;">chat_bubble_outline</i>
            <p class="mt-3">Enter an Application ID and click "Start Chat" to begin</p>
          </div>

          <div *ngIf="isListening && isLoading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading messages...</span>
            </div>
            <p class="mt-2 text-muted">Loading messages...</p>
          </div>

          <div *ngIf="isListening && !isLoading && messages.length === 0" class="text-center text-muted py-5">
            <i class="material-icons" style="font-size: 48px;">forum</i>
            <p class="mt-3">No messages yet. Start the conversation!</p>
          </div>

          <!-- Messages List -->
          <div *ngIf="isListening && messages.length > 0">
            <div *ngFor="let message of messages" class="mb-3">
              <div class="d-flex" [class.justify-content-end]="message.isCurrentUser">
                <div class="message-bubble"
                     [class.message-sent]="message.isCurrentUser"
                     [class.message-received]="!message.isCurrentUser"
                     [class.message-unread]="!message.hasRead"
                     style="max-width: 70%;">
                  <div class="message-header">
                    <strong>{{ message.senderName }}</strong>
                    <small class="text-muted ml-2">{{ message.sentOn | date:'short' }}</small>
                  </div>
                  <div class="message-body">
                    {{ message.text }}
                  </div>
                  <div class="message-footer" *ngIf="!message.isCurrentUser">
                    <span *ngIf="message.hasRead" class="badge badge-success badge-sm">
                      <i class="material-icons" style="vertical-align: middle; font-size: 12px;">done_all</i>
                      Read
                    </span>
                    <button
                      *ngIf="!message.hasRead"
                      class="btn btn-sm btn-outline-primary"
                      (click)="markAsRead(message.id)"
                    >
                      <i class="material-icons" style="vertical-align: middle; font-size: 14px;">done</i>
                      Mark as Read
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Typing Indicator -->
            <div *ngIf="otherUserTyping" class="text-muted small ml-3">
              <i class="material-icons" style="vertical-align: middle; font-size: 14px;">edit</i>
              {{typingUserName}} is typing...
            </div>
          </div>
        </div>

        <!-- Message Input -->
        <div class="card-footer bg-light" *ngIf="isListening">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              [(ngModel)]="currentMessage"
              placeholder="Type a message..."
              (keyup)="onTyping()"
              (keyup.enter)="sendMessage()"
              [disabled]="!isListening"
            />
            <div class="input-group-append">
              <button
                class="btn btn-primary"
                (click)="sendMessage()"
                [disabled]="!currentMessage.trim() || !isListening"
              >
                <i class="material-icons" style="vertical-align: middle;">send</i>
                Send
              </button>
            </div>
          </div>
          <small class="text-muted">Press Enter to send</small>
        </div>
      </div>
    </div>
  </div>
</div>
